import { useState } from "react";

export default function useModalStates(modalNames) {
  const [modalStates, setModalStates] = useState(
    modalNames.reduce((acc, name) => {
      acc[name] = false;
      return acc;
    }, {})
  );

  const createHandlers = (modalName) => ({
    open: () => setModalStates(prev => ({ ...prev, [modalName]: true })),
    close: () => setModalStates(prev => ({ ...prev, [modalName]: false })),
    isOpen: modalStates[modalName],
  });

  const handlers = modalNames.reduce((acc, name) => {
    acc[name] = createHandlers(name);
    return acc;
  }, {});

  return handlers;
} 